<div class="flex flex-col gap-40">
  <div class="header-section" data-test-id="header-section">
    <layout-container [mode]="LayoutContainerModes.fullWidth">
      <div class="header-section-main-text flex flex-col flex-center-center max-md:gap-12 md:gap-24">
        <h1 class="m-0"
            data-test-id="header-section-header">
          Hi John
        </h1>
        <p class="header-subtitle m-0 header-light">
          You are in a place where you can update your current status and check the remaining information from your profile and, if appropriate, update it.
        </p>
      </div>
    </layout-container>
  </div>
  <div>
    <availability-update-form></availability-update-form>
  </div>
</div>
